// WIP: Evaluate to merge in one object
export const ADMIN_ACCOUNTS_INPUT_EVENT = {
  FROM_DOMIC_SUBSCRIPTION: 'DOMIC_SUBSCRIPTION',
  FROM_DOWNPAYMENT_APPLICATION: 'DOWNPAYMENT_APPLICATION',
  FROM_FUNNEL_4_ECOSYSTEM: 'FUNNEL_4_ECOSYSTEM',
  FROM_MANAGE_DOMIC_SUBSCRIPTION: 'MANAGE_DOMIC_SUBSCRIPTION',
  FROM_PERSONAL_LOANS: 'PERSONAL_LOANS',
  FROM_REIMBURSEMENTS: 'REIMBURSEMENTS',
} as const;

export const ADMIN_ACCOUNTS_EVENTS = {
  ADD_ACCOUNT: 'ADD_CARD',
  ADD_ACCOUNT_SECONDARY: 'ADD_CARD_SECONDARY',
  ADDED_ACCOUNT: 'ADDED_CARD',
  ADDED_ACCOUNT_SECONDARY: 'ADDED_ACCOUNT_SECONDARY',
  BACK: 'BACK',
  DELETED_ACCOUNT: 'DELETED_CARD',
  MANAGE_ACCOUNTS: 'MANAGE_CARDS',
  SELECTED_ACCOUNT: 'SELECTED_ACCOUNT',
} as const;

// TODO: Split internal result and exit result in their own enums
export const ADMIN_ACCOUNTS_RESULT = {
  IN_ACCOUNT_FORM: 'IN_ACCOUNT_FORM',
  IN_CHECKOUT_FORM: 'IN_CHECKOUT_FORM',
  IN_CONSUMER_PORTAL: 'IN_CONSUMER_PORTAL', // EXIT RESULT
  IN_DOMIC_SUBSCRIPTION_APPLICATION: 'IN_DOMIC_SUBSCRIPTION_APPLICATION', // EXIT RESULT
  IN_DOMIC_SUBSCRIPTION_FORM: 'IN_DOMIC_SUBSCRIPTION_FORM', // EXIT RESULT
  IN_DOWNPAYMENT_APPLICATION: 'IN_DOWNPAYMENT_APPLICATION', // EXIT RESULT
  IN_FUNNEL_4_ECOSYSTEM: 'IN_FUNNEL_4_ECOSYSTEM', // EXIT RESULT
  IN_KEEP_SCREEN: 'IN_KEEP_SCREEN',
  IN_MANAGE_ACCOUNTS: 'IN_MANAGE_ACCOUNTS',
  IN_MANAGE_CARDS: 'IN_MANAGE_CARDS',
  IN_MANAGE_DOMIC_SUBSCRIPTION: 'IN_MANAGE_DOMIC_SUBSCRIPTION',
  IN_MANAGE_REIMBURSEMENTS: 'IN_MANAGE_REIMBURSEMENTS',
  IN_PERSONAL_LOANS: 'IN_PERSONAL_LOANS', // EXIT RESULT
  IN_REIMBURSEMENTS: 'IN_REIMBURSEMENTS', // EXIT RESULT
  IN_REIMBURSEMENTS_ACCOUNT_FORM: 'IN_REIMBURSEMENTS_ACCOUNT_FORM',
  IN_UNHANDLED_STATE: 'IN_UNHANDLED_STATE',
} as const;

export const isExitResult = (result: string) => {
  const {
    IN_CONSUMER_PORTAL,
    IN_DOMIC_SUBSCRIPTION_APPLICATION,
    IN_DOWNPAYMENT_APPLICATION,
    IN_FUNNEL_4_ECOSYSTEM,
    IN_PERSONAL_LOANS,
    IN_REIMBURSEMENTS,
  } = ADMIN_ACCOUNTS_RESULT;

  const exitResults: string[] = [
    IN_FUNNEL_4_ECOSYSTEM,
    IN_DOMIC_SUBSCRIPTION_APPLICATION,
    IN_DOWNPAYMENT_APPLICATION,
    IN_CONSUMER_PORTAL,
    IN_PERSONAL_LOANS,
    IN_REIMBURSEMENTS,
  ];

  return exitResults.includes(result);
};

export const DECISION_FLOW_ACTIONS = {
  FORCE_REFRESH: 'force_refresh',
  KEEP: 'keep',
  REFRESH: 'refresh',
  RETURN: 'return',
} as const;

type ValuesOf<T extends object> = T[keyof T]

export type FlowDataFrom = ValuesOf<typeof ADMIN_ACCOUNTS_INPUT_EVENT>;
export type FlowDataEvent = ValuesOf<typeof ADMIN_ACCOUNTS_EVENTS>;
export type FlowDataAction = ValuesOf<typeof DECISION_FLOW_ACTIONS>;
export type FlowDataResult = ValuesOf<typeof ADMIN_ACCOUNTS_RESULT>;

export const ACTION_TO_EVENT: Partial<Record<FlowDataAction, FlowDataEvent>> = {
  [DECISION_FLOW_ACTIONS.RETURN]: ADMIN_ACCOUNTS_EVENTS.BACK,
};

export const TARGET_TO_EVENT: Partial<Record<FlowDataResult, FlowDataEvent>> = {
  [ADMIN_ACCOUNTS_RESULT.IN_ACCOUNT_FORM]: ADMIN_ACCOUNTS_EVENTS.ADD_ACCOUNT,
  [ADMIN_ACCOUNTS_RESULT.IN_CHECKOUT_FORM]: ADMIN_ACCOUNTS_EVENTS.ADD_ACCOUNT,
  [ADMIN_ACCOUNTS_RESULT.IN_DOMIC_SUBSCRIPTION_FORM]: ADMIN_ACCOUNTS_EVENTS.ADD_ACCOUNT,
  [ADMIN_ACCOUNTS_RESULT.IN_MANAGE_ACCOUNTS]: ADMIN_ACCOUNTS_EVENTS.MANAGE_ACCOUNTS,
  [ADMIN_ACCOUNTS_RESULT.IN_MANAGE_CARDS]: ADMIN_ACCOUNTS_EVENTS.MANAGE_ACCOUNTS,
  [ADMIN_ACCOUNTS_RESULT.IN_MANAGE_DOMIC_SUBSCRIPTION]: ADMIN_ACCOUNTS_EVENTS.MANAGE_ACCOUNTS,
  [ADMIN_ACCOUNTS_RESULT.IN_MANAGE_REIMBURSEMENTS]: ADMIN_ACCOUNTS_EVENTS.MANAGE_ACCOUNTS,
  [ADMIN_ACCOUNTS_RESULT.IN_REIMBURSEMENTS_ACCOUNT_FORM]: ADMIN_ACCOUNTS_EVENTS.ADD_ACCOUNT,
};
